import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/pricing/page.tsx");
